/**
 * @param {import('./types').EcrionFormState} state
 * @param {string} fieldId
 * @param {string} error
 */
var setError = function setError(state, fieldId, error) {
  if (!state) return;
  state.meta = state.meta || {};
  state.meta[fieldId] = state.meta[fieldId] || {};
  state.meta[fieldId].error = error || '';
};
/**
 * @param {import('./types').EcrionFormState} state
 * @param {string} fieldId
 * @param {string} name
 * @param {any} value
 */


var setMetaProp = function setMetaProp(state, fieldId, name, value) {
  if (!state) return;
  state.meta = state.meta || {};
  state.meta[fieldId] = state.meta[fieldId] || {};
  state.meta[fieldId][name] = value;
};

export default {
  setError: setError,
  setMetaProp: setMetaProp
};